import React,{useState} from "react";
import {
Modal,
Form,
Row,
Col,
Button
} from "react-bootstrap";
import {TiTimes} from "react-icons/ti";

export default function PersonalInfoModal({show,handleClose}){

const [formData,setFormData]=useState({
passportNo:"",
passportExpiry:"",
nationality:"",
religion:"",
maritalStatus:"",
spouse:"",
children:""
});

const handleChange=(e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

return(
<Modal
show={show}
onHide={handleClose}
centered
size="xl"
>

<Modal.Header
style={{
padding:"20px 22px",
borderBottom:"1px solid #e5e7eb",
position:"relative"
}}
>

<Modal.Title
style={{
fontSize:"22px",
fontWeight:"700",
color:"#1e2b4d"
}}
>
Edit Personal Info
</Modal.Title>

<button
onClick={handleClose}
style={{
position:"absolute",
right:"18px",
top:"18px",
border:"none",
background:"#6b7280",
width:"30px",
height:"30px",
borderRadius:"50%",
color:"#fff"
}}
>
<TiTimes/>
</button>

</Modal.Header>


<Modal.Body style={{padding:"24px 22px"}}>

<Row>

<Col md={6} xs={12}>
<Field
label="Passport No *"
name="passportNo"
value={formData.passportNo}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Form.Group className="mb-4">
<Form.Label>
Passport Expiry Date <span style={{color:"red"}}>*</span>
</Form.Label>

<Form.Control
type="date"
name="passportExpiry"
value={formData.passportExpiry}
onChange={handleChange}
/>
</Form.Group>
</Col>


<Col md={6} xs={12}>
<Field
label="Nationality *"
name="nationality"
value={formData.nationality}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Religion"
name="religion"
value={formData.religion}
onChange={handleChange}
/>
</Col>


<Col md={12}>
<Form.Group className="mb-4">
<Form.Label>
Marital status <span style={{color:"red"}}>*</span>
</Form.Label>

<Form.Select
name="maritalStatus"
value={formData.maritalStatus}
onChange={handleChange}
>
<option>Select</option>
<option>Single</option>
<option>Married</option>
</Form.Select>

</Form.Group>
</Col>


<Col md={6} xs={12}>
<Field
label="Employment spouse"
name="spouse"
value={formData.spouse}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="No. of children"
name="children"
value={formData.children}
onChange={handleChange}
/>
</Col>

</Row>

</Modal.Body>


<Modal.Footer
style={{
borderTop:"1px solid #e5e7eb",
padding:"14px 22px"
}}
>

<Button
variant="light"
onClick={handleClose}
style={{
border:"1px solid #d1d5db"
}}
>
Cancel
</Button>

<Button
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</Modal.Footer>

</Modal>
);
}

function Field({
label,
name,
value,
onChange
}){
return(
<Form.Group className="mb-4">
<Form.Label>{label}</Form.Label>

<Form.Control
name={name}
value={value}
onChange={onChange}
/>

</Form.Group>
);
}